module.exports = __webpack_public_path__ + "static/media/30 Open Guard.ad197fa8.jpg";